import createRoute    from '@widesk-ui/tools/createRoute';
import PromoCodeModel from '@models/shop/PromoCodeModel';

export default createRoute.splitView('/promo_codes', 'shop', 'PromoCodeSplitView', PromoCodeModel.localize('plural'));
